import { render } from "./salary_details.html?vue&type=template&id=395be504&external"
import script from "./salary_details.js?vue&type=script&lang=js&external"
export * from "./salary_details.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__